import axios from "axios";

const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL;
const sameSite = (a, b) => a.replace(/^www\./, "") === b.replace(/^www\./, "");
// www.<domain> and <domain> share the API via the same proxy; staying on the page's own origin keeps auth cookies first-party.
export const BACKEND = typeof window !== "undefined" && window.location.hostname !== "localhost" && sameSite(window.location.hostname, new URL(ENV_BACKEND).hostname)
  ? window.location.origin : ENV_BACKEND;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new CustomEvent("cpd:session-expired"));
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  if (e?.response?.status === 401) return "Your session has expired — please log in again.";
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const img = (url) => `${BACKEND}${url}`;
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const SIZES = [
  { key: "8x8", label: "Square", dims: "8 × 8 in", ratio: 1, from: 1499 },
  { key: "8x11", label: "Portrait", dims: "8 × 11 in", ratio: 8 / 11, from: 1799 },
  { key: "11x8.5", label: "Landscape", dims: "11 × 8.5 in", ratio: 11 / 8.5, from: 1999 },
];
export const THEMES = [
  { key: "heritage", label: "Heritage", desc: "Linen tones, classic serif — weddings & family", swatch: "#F6F1E8" },
  { key: "minimal", label: "Modern Studio", desc: "Gallery white, clean sans", swatch: "#FFFFFF" },
  { key: "travel", label: "Travel Journal", desc: "Sand paper, typewriter notes", swatch: "#F3EDE2" },
  { key: "baby", label: "Little Ones", desc: "Soft blush, gentle type", swatch: "#FBF4EF" },
];
export const ratioOf = (size) => SIZES.find((s) => s.key === size)?.ratio || 1;
